import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollTo = (e: React.MouseEvent, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  // Mapeo exacto a tus componentes
  const navItems = [
    { name: 'Servicios', id: 'services' },
    { name: 'Nosotros', id: 'about' },
    { name: 'Soluciones', id: 'services' }, // O el ID de Features si prefieres
    { name: 'Contacto', id: 'contacto' }    // <--- Vinculado a la imagen que enviaste
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-500 ${
      scrolled 
        ? 'bg-[#050608]/80 backdrop-blur-xl border-b border-white/5 py-3' 
        : 'bg-transparent py-5'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex items-center justify-between h-14">
          
          <div 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-3 group cursor-pointer"
          >
            <div className="relative w-9 h-9">
              <div className="absolute inset-0 bg-[#00C2FF] blur-lg opacity-20 group-hover:opacity-40 transition-opacity" />
              <img src="/code.svg" alt="Logo" className="relative w-full h-full object-contain" />
            </div>
            <span className="text-xl font-bold text-white">CodeLiance</span>
          </div>

          <div className="hidden md:flex items-center gap-10">
            {navItems.map((item) => (
              <a 
                key={item.name}
                href={`#${item.id}`}
                onClick={(e) => handleScrollTo(e, item.id)}
                className="text-[13px] font-medium text-[#86868b] hover:text-white transition-colors tracking-wide"
              >
                {item.name}
              </a>
            ))}
            
            <button 
              onClick={(e) => handleScrollTo(e, 'contacto')} // <--- Lleva a la zona de contacto
              className="ml-4 px-5 py-2 bg-white text-black text-xs font-bold rounded-full hover:bg-[#00C2FF] hover:text-white transition-all duration-500 shadow-sm hover:shadow-[0_0_20px_rgba(0,194,255,0.4)]"
            >
              Empezar Proyecto
            </button>
          </div>

          <button 
            className="md:hidden p-2 text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={isMobileMenuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {/* Menú Móvil */}
      <div className={`md:hidden absolute w-full bg-[#050608] border-b border-white/5 transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="px-6 py-8 flex flex-col gap-6">
          {navItems.map((item) => (
            <a 
              key={item.name}
              href={`#${item.id}`}
              onClick={(e) => handleScrollTo(e, item.id)}
              className="text-lg font-medium text-[#86868b]"
            >
              {item.name}
            </a>
          ))}
          <button 
            onClick={(e) => handleScrollTo(e, 'contacto')}
            className="w-full py-4 bg-[#00C2FF] text-white font-bold rounded-2xl"
          >
            Empezar Proyecto
          </button>
        </div>
      </div>
    </nav>
  );
}